module.exports = __webpack_public_path__ + "static/fonts/iconfont.4ebc7d4a.woff";